<!--
  组件说明：角色切换组件
  调用示范：
  <el-dialog title="选择角色" :visible.sync="showDialog" width="30%" center>
    <changeRole :visible.sync="showDialog"></changeRole>
  </el-dialog>
-->
<template>
  <div style="text-align:center;">
    <el-select v-model="jsdh" placeholder="请选择角色" style="width: 90%">
    <el-option
      v-for="item in data"
      :key="item.jsdh"
      :label="item.jsmc"
      :value="item.jsdh">
    </el-option>
  </el-select>
    <div class="buttons" style="text-align:center; margin-top:10px">
      <el-button type="primary" @click="changeRole">确定</el-button>
    </div>
  </div>
</template>
<script>
import { changeRole } from '@/api/baseApi'
export default {
  data () {
    return {
      jsdh: null,
      data: []
    }
  },
  props: {
    visible: Boolean
  },
  methods: {
    // 确定
    changeRole () {
      const params = { jsdh: this.jsdh }
      changeRole(params).then(res => {
        this.$http.callback(res, () => {
          this.$emit('update:visible', false)
          // 更新user
          const user = this.$store.state.user
          user.jsdh = this.jsdh
          user.jslx = this.data.find(a => a.jsdh === this.jsdh).jslx
          this.$store.commit('setUser', user)
          // 进入首页
          this.$router.push({
            path: '/'
          })
        })
      })
    }
  },
  mounted () {
    // 加载结束下拉框
    this.data = this.$store.state.user.xtbAqjsList
    // 设置默认角色
    if (this.$store.state.user.jsdh) {
      this.jsdh = this.$store.state.user.jsdh
    }
  }
}
</script>
